import { State } from '../../../../types'
import { ViewConstants } from '../../../actions/views/viewConstants'

export const getJsonApiEntities = (state: State): State['jsonApiEntities'] =>
  state.jsonApiEntities

export const getJsonApiEntitiesMeta = (
  state: State
): Record<string, any> | undefined =>
  state.jsonApiEntities && state.jsonApiEntities.meta

export const getEntityDataByViewState = (
  state: State
): State['entityDataByView'] => state.entityDataByView

export const getEntityDataViewState = (
  state: State,
  viewConstant: ViewConstants
): Record<string, any> | undefined =>
  getEntityDataByViewState(state)[viewConstant]
